import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const BrushIcon = createIcon({
  displayName: 'BrushIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M20.221,4.292v0c-0.783,-0.783 -2.038,-0.824 -2.871,-0.096l-8.037,7.032c-0.871,0.762 -0.915,2.101 -0.097,2.919l1.149,1.149c0.818,0.818 2.158,0.773 2.919,-0.097l7.032,-8.037c0.729,-0.832 0.687,-2.087 -0.095,-2.87Z"></path>
        <path d="M10.87,9.87l3.78,3.78"></path>
        <path d="M3.599,20.323h3.703c2.985,0 4.48,-3.609 2.369,-5.72v0c-1.552,-1.552 -4.188,-0.981 -4.958,1.074l-1.522,4.058c-0.106,0.285 0.104,0.588 0.408,0.588Z"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const Brush: FC<IconProps> = (props) => {
  return <CustomIcon as={BrushIcon} {...props} />
}

export default memo(Brush)
